import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  ListContainer,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input, ListBeProperty, ListFooter } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabM as AprResponseModel, AprEtsTabMItem, ModelPropertyBase } from "generated/openApi";
import { useInitListFilter, useList, useListFilter } from "hooks";

import "moment-timezone";

export const AprEtsTabM = (props: {
  data: AprResponseModel | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {

  const nonTargetSchoolField = () => {
    const propertyName = pn<AprResponseModel>("nonTargetSchoolTotal");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.nonTargetSchoolTotal}
      </DataDisplay>
    );
  };


  const ncesField = (schoolRow: AprEtsTabMItem) => {
    const propertyName = pn<AprEtsTabMItem>("ncesId");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.ncesId}
      </DataDisplay>
    );
  };

  const schoolNameField = (schoolRow: AprEtsTabMItem) => {
    const propertyName = pn<AprEtsTabMItem>("targetSchoolName");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.targetSchoolName}
      </DataDisplay>
    );
  };

  const cityField = (schoolRow: AprEtsTabMItem) => {
    const propertyName = pn<AprEtsTabMItem>("city");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.city}
      </DataDisplay>
    );
  };

  const stateField = (schoolRow: AprEtsTabMItem) => {
    const propertyName = pn<AprEtsTabMItem>("state");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.state}
      </DataDisplay>
    );
  };

  const zipCodeField = (schoolRow: AprEtsTabMItem) => {
    const propertyName = pn<AprEtsTabMItem>("zipCode");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.zipCode}
      </DataDisplay>
    );
  };

  const numberServedField = (schoolRow: AprEtsTabMItem) => {
    const propertyName = pn<AprEtsTabMItem>("numberServed");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.numberServed}
      </DataDisplay>
    );
  };

  const dualEnrollmentField = (schoolRow: AprEtsTabMItem) => {
    const propertyName = pn<AprEtsTabMItem>("dualEnrolled");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {schoolRow.dualEnrolled}
      </DataDisplay>
    );
  };

  const renderSchoolRow = (schoolRow: AprEtsTabMItem, index: number) => {
    return (
      <Grid item xs={12}>
        <Grid container spacing="md">
          <Grid item xs={2}>
            {ncesField(schoolRow)}
          </Grid>
          <Grid item xs={2}>
            {schoolNameField(schoolRow)}
          </Grid>
          <Grid item xs={2}>
            {cityField(schoolRow)}
          </Grid>
          <Grid item xs={1}>
            {stateField(schoolRow)}
          </Grid>
          <Grid item xs={1}>
            {zipCodeField(schoolRow)}
          </Grid>
          <Grid item xs={2}>
            {numberServedField(schoolRow)}
          </Grid>
          <Grid item xs={2}>
            {dualEnrollmentField(schoolRow)}
          </Grid>
        </Grid>
      </Grid>
    );
    }

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Target Schools</Typography>
        <Grid container spacing="lg">
          {props.data?.schoolRows?.map((q, index) => renderSchoolRow(q, index))}

          <GridBreak />

          <Grid item xs={6}>
            <PieChart id="pie-tab-m" dataSource={props.data?.chartValues} palette="Bright" title="Participants" width="100%">
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>

          <GridBreak />

          {nonTargetSchoolField()}
          
        </Grid>
      </Stack>
    </Card>
  );
};
